// For Firebase JS SDK v7.20.0 and later, measurementId is optional

  import firebase from "firebase";
  
  const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyBxM7vbGKFt7xPLJWjQX98rYL_Lky_TLac",
    authDomain: "react-firebase-todo-ap.firebaseapp.com",
    databaseURL: "https://react-firebase-todo-ap.firebaseio.com",
    projectId: "react-firebase-todo-ap",
    storageBucket: "react-firebase-todo-ap.appspot.com",
    messagingSenderId: "502440932029",
    appId: "1:502440932029:web:2b0792795f9101361dfdd4",
    measurementId: "G-RES3KN7W8G"
  });

  const db = firebaseApp.firestore();

  export default db ;